// ============================================================================
// PORTUGUESE TRANSLATIONS - BIBLE FACTS
// ============================================================================
// Fatos fascinantes sobre a Bíblia

export const bibleFacts = [
  {
    category: "estrutura",
    text: "A Bíblia contém 66 livros escritos por mais de 40 autores diferentes ao longo de aproximadamente 1500 anos",
    source: "Estrutura bíblica canônica"
  },
  {
    category: "tamanho",
    text: "A Bíblia contém 31.173 versículos, 1.189 capítulos e aproximadamente 783.137 palavras em sua versão original",
    source: "Análise textual bíblica"
  },
  {
    category: "tradução",
    text: "A Bíblia foi traduzida completa ou parcialmente em mais de 3.000 idiomas, tornando-a o livro mais traduzido do mundo",
    source: "Sociedades Bíblicas Unidas"
  },
  {
    category: "versículo",
    text: "O versículo mais curto da Bíblia é 'Jesus chorou' (João 11:35), enquanto o mais longo é Ester 8:9",
    source: "Análise textual bíblica"
  },
  {
    category: "popularidade",
    text: "A Bíblia é o livro mais vendido de todos os tempos, com mais de 5 bilhões de cópias distribuídas",
    source: "Registros editoriais"
  },
  {
    category: "história",
    text: "Os Manuscritos do Mar Morto, descobertos em 1947, contêm manuscritos bíblicos datados de mais de 2.000 anos atrás",
    source: "Arqueologia bíblica"
  },
  {
    category: "centro",
    text: "O capítulo central da Bíblia é o Salmo 118, e o versículo central é o Salmo 118:8",
    source: "Estrutura numérica bíblica"
  }
];

export default bibleFacts;
